<template>
  <div class="product__downloads">
    <CustomButton
      v-if="manual"
      type="secondary"
      :url="manual"
      rel="nofollow"
    >
      <span class="iconify svg--download mr-3" />
      {{ $t('Technical - manual.pdf') }}
    </CustomButton>
    <p
      v-if="shouldShowRequestTranslationText"
      class="text-sm leading-5 mt-4"
    >
      <i18n-t
      keypath="salesforce-form-request-translation">
        <template #contactFormLink>
          <span
            class="underline text-EXPONDO-secondary cursor-pointer"
            data-testid="request-translation-link"
            @click="openContactForm"
          >
            {{ $t('salesforce-form-request-translation-contactFormLink') }}
          </span>
        </template>
      </i18n-t>
    </p>
  </div>
</template>

<script lang="ts">


import { hasManualTranslationsAlways } from '~~/helpers/hasManualTranslationsAlways';
import { LINK_TYPE } from '~~/types/components/Link/LinkType';
import isStringTrue from '~~/helpers/dataStructure/isStringTrue';

export default defineComponent({

  props: {
    manual: {
      type: String,
      required: true,
    },
    sku: {
      type: String,
      required: true,
    },
  },
  setup(props) {

    const { countryCode } = useLocalization();
    const { openWebformModal } = useWebformModalStore();

    const shouldShowRequestTranslationText =
      computed(() =>
        !props.manual || !hasManualTranslationsAlways(countryCode.value),
      );
    const openContactForm = (): void => {

      openWebformModal({ sku: props.sku, shouldPrefillFormForManual: true });
    
    };

    return {
      shouldShowRequestTranslationText,
      openContactForm,
      LINK_TYPE,
    };
  
  },
});

</script>
